import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { App } from './App';
import { AuthProvider } from './lib/auth';
import { registerServiceWorker } from './lib/pwa';
import { applyTheme, readTheme, watchSystemTheme } from './lib/theme';
import { detectLocale, setLocale } from './lib/i18n';
// Lexend for UI, Gentium Book Plus for Yorùbá text: full support for under-dots +
// stacked tone marks (ọ̀, ẹ́, ṣ). Bundled, not fetched from Google.
import '@fontsource-variable/bricolage-grotesque';
import '@fontsource/lexend/300.css';
import '@fontsource/lexend/400.css';
import '@fontsource/lexend/500.css';
import '@fontsource/lexend/600.css';
import '@fontsource/lexend/700.css';
import '@fontsource/gentium-book-plus/400.css';
import '@fontsource/gentium-book-plus/700.css';
import '@fontsource/gentium-book-plus/400-italic.css';
import './styles/app.css';

// Before React mounts. The markup already says dark, so this only does visible
// work for someone who chose light or "match my device".
applyTheme(readTheme());
watchSystemTheme();
// English is bundled, so this resolves immediately for English and only awaits a
// network round trip for a locale the person actually chose. Not awaited: the
// app renders in English and swaps the moment the catalogue lands, rather than
// holding a blank screen on a slow connection.
void setLocale(detectLocale());

registerServiceWorker();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <App />
      </AuthProvider>
    </BrowserRouter>
  </StrictMode>,
);
